export const toStartCase = (word: string): string =>
  word[0]?.toUpperCase() + word.slice(1);
